import React, { Component } from 'react'
import Relay from 'react-relay'

import SelectUser from './SelectUser'
import Circle from './Circle'

import { appStyles, colors, fonts } from '../theme'

class UserList extends Component {
	state = {
		loaded: false,
		users: [],
    changed: false,
	}

	componentDidMount() {
		this.componentWillReceiveProps(this.props)
	}

	componentWillReceiveProps(nextProps) {
		if (!this.state.loaded &&
					nextProps.users) {
			this.setState({
				loaded: true,
        changed: false,
				users: nextProps.users,
				usersSrc: nextProps.users,
			})
		}
	}

	_userAlreadyExist = (user) =>
		this.state.users.find(
			(userA) => userA.id === user.id
		)

	_handleAddUser = (user) => {
    if (this._userAlreadyExist(user)) return false

    this.setState({
      changed: true,
      users: [
				...this.state.users,
				user
			]
    }, () => this.props.onChange && this.props.onChange(this.state.users))
	}

	_removeUser = (index) =>
		this.setState({
      changed: true,
			users:
				this.state.users.filter((item, i) => i !== index),
		}, () => this.props.onChange && this.props.onChange(this.state.users))

	_handleSave = () => {
		this.props.onSave(this.state.users)
		this.setState({
			changed: false,
		})
	}

	_handleCancel = () => {
		this.setState({
      changed: false,
			users: this.state.usersSrc,
		})
    this.props.onChange && this.props.onChange(this.state.usersSrc)
	}

	render() {
		const { user, viewer } = this.props
		const { users } = this.state

		return(
			<section style={styles.container}>
				<div style={styles.pageHeader}>{this.props.title}</div>
				<div style={styles.row}>
					<SelectUser
						viewer={viewer}
						onSelectedUser={this._handleAddUser}
						notUsers={user? [user, ...user.authorized_managers.map((am) => am.user)] : []}
					/>
				</div>
				<div style={styles.row}>
					<ul style={styles.list}>
						{users.map((user, index) => (
							<li
									key={index}
									style={styles.listItem}
							>
								<Circle image={user.avatar} style={styles.icon} />
								{user.pseudo}
								<span style={styles.removeCross} onClick={() => this._removeUser(index)}>
									<i className="glyphicon glyphicon-remove-circle" style={styles.cancelIcon} aria-hidden="true"></i>
								</span>
							</li>
						))}
					</ul>
				</div>
				{this.state.changed &&
					<div style={styles.row}>
						<section>
							<button style={appStyles.blueButton} onClick={this._handleSave}>Update</button>
							<button style={appStyles.grayButton} onClick={this._handleCancel}>Cancel</button>
						</section>
					</div>
				}
			</section>
		)
	}
}

const styles = {
	list: {
		width: '100%',
	},
	listItem: {
		paddingBottom: 10,
		color: '#515151',
		fontSize: 16,
		fontWeight: 500,
		fontFamily: 'Lato',
		borderBottomWidth: 1,
		borderColor: colors.blue,
		borderStyle: 'solid',
		display: 'flex',
		flexDirection: 'row',
		justifyContent: 'flex-start',
		alignItems: 'center',
		maxWidth: 500,
	},
	removeCross: {
		marginLeft: 'auto',
		width: 5,
		color: colors.gray,
		marginRight: '15px',
		cursor: 'pointer',
		fontSize: '20px',
	},
	cancelIcon: {
		marginRight: 15,
	},
	icon: {
    display: 'inline-block',
    width: 38,
    height: 38,
    margin: '5px 13px 0 32px',
  },
	pageHeader: {
		fontWeight: 600,
		fontSize: 17,
		padding: 10,
	}
}

export default Relay.createContainer(UserList, {
  fragments: {
		viewer: (variables) => Relay.QL`
      fragment on Viewer {
				${SelectUser.getFragment('viewer', variables)}
			}
    `,
  },
})



// WEBPACK FOOTER //
// ./src/components/UserList.js